import { useEffect, useState } from 'react'
import type { SmartGuideLine } from '@/lib/guides/smart-guides'

/**
 * The smart-guide lines currently painted by the visual layer, and whether smart guides are on at
 * all (both `showGuides` and `showSmartGuides`). Turning them off clears whatever is painted.
 */
export function useSmartGuidesState({
  showGuides,
  showSmartGuides,
}: {
  showGuides: boolean
  showSmartGuides: boolean
}) {
  const [activeSmartGuides, setActiveSmartGuides] = useState<SmartGuideLine[]>([])
  const effectiveSmartGuides = showGuides && showSmartGuides

  useEffect(() => {
    if (!effectiveSmartGuides) {
      setActiveSmartGuides([])
    }
  }, [effectiveSmartGuides])

  return { activeSmartGuides, setActiveSmartGuides, effectiveSmartGuides }
}
